import { render, staticRenderFns } from "./addReceive.vue?vue&type=template&id=6eaa8d03&scoped=true&"
import script from "./addReceive.vue?vue&type=script&lang=js&"
export * from "./addReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaa8d03",
  null
  
)

export default component.exports